module.exports = __webpack_public_path__ + "img/exccAuthType2.7d536b4c.png";